import React from "react";

export const exportPlayerProfileShootingDrills = (shootingDrillsData) => {
  const styleHeaderCss = {
    fill: {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "e6eefb" },
    },
    font: { sz: "11", bold: true, color: { argb: "1d428a" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    },
    alignment: {
      wrapText: true,
      horizontal: "center",
      vertical: "top",
    },
  };

  const shootingDrils = {
    title: "Shooting Drills Overview",
    headerNames: [
      {
        title: "Shooting Drill",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Result",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Percentage",
        width: 30,
        style: styleHeaderCss,
      },
    ],
    data:
      shootingDrillsData && shootingDrillsData.length > 0
        ? shootingDrillsData[0].map((record) => ({
            region: record.region ? record.region : 0,
            result: record.result ? record.result : 0,
            percentage: record.percentage ? record.percentage : 0,
          }))
        : [],
    columnStyles: Array(3).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const spotUpDrillData = {
    title: "Spot Up Drill",
    headerNames: [
      {
        title: "Region",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Result",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Percentage",
        width: 30,
        style: styleHeaderCss,
      },
    ],
    data:
      shootingDrillsData && shootingDrillsData.length > 0
        ? shootingDrillsData[1].map((record) => ({
            region: record.region ? record.region : 0,
            result: record.result ? record.result : 0,
            percentage: record.percentage ? record.percentage : 0,
          }))
        : [],
    columnStyles: Array(3).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const threePointStarDrillData = {
    title: "3 Point Star Drill",
    headerNames: [
      {
        title: "Region",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Result",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Percentage",
        width: 30,
        style: styleHeaderCss,
      },
    ],
    data:
      shootingDrillsData && shootingDrillsData.length > 0
        ? shootingDrillsData[2].map((record) => ({
            region: record.region ? record.region : 0,
            result: record.result ? record.result : 0,
            percentage: record.percentage ? record.percentage : 0,
          }))
        : [],
    columnStyles: Array(3).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const midRangeStarDrillData = {
    title: "Mid Range Star Drill",
    headerNames: [
      {
        title: "Region",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Result",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Percentage",
        width: 30,
        style: styleHeaderCss,
      },
    ],
    data:
      shootingDrillsData && shootingDrillsData.length > 0
        ? shootingDrillsData[3].map((record) => ({
            region: record.region ? record.region : 0,
            result: record.result ? record.result : 0,
            percentage: record.percentage ? record.percentage : 0,
          }))
        : [],
    columnStyles: Array(3).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const sideMidSideStarDrillData = {
    title: "Side Mid Side Drill",
    headerNames: [
      {
        title: "Region",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Result",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Percentage",
        width: 30,
        style: styleHeaderCss,
      },
    ],
    data:
      shootingDrillsData && shootingDrillsData.length > 0
        ? shootingDrillsData[4].map((record) => ({
            region: record.region ? record.region : 0,
            result: record.result ? record.result : 0,
            percentage: record.percentage ? record.percentage : 0,
          }))
        : [],
    columnStyles: Array(3).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const midSideMidStarDrillData = {
    title: "Mid Side Mid Drill",
    headerNames: [
      {
        title: "Region",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Result",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Percentage",
        width: 30,
        style: styleHeaderCss,
      },
    ],
    data:
      shootingDrillsData && shootingDrillsData.length > 0
        ? shootingDrillsData[5].map((record) => ({
            region: record.region ? record.region : 0,
            result: record.result ? record.result : 0,
            percentage: record.percentage ? record.percentage : 0,
          }))
        : [],
    columnStyles: Array(3).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const offTheDribbleDrillData = {
    title: "Off the Dribble Shooting",
    headerNames: [
      {
        title: "Region",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Result",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Percentage",
        width: 30,
        style: styleHeaderCss,
      },
    ],
    data:
      shootingDrillsData && shootingDrillsData.length > 0
        ? shootingDrillsData[6].map((record) => ({
            region: record.region ? record.region : 0,
            result: record.result ? record.result : 0,
            percentage: record.percentage ? record.percentage : 0,
          }))
        : [],
    columnStyles: Array(3).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const freeThrowsDrillData = {
    title: "Free Throws",
    headerNames: [
      {
        title: "Region",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Result",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Percentage",
        width: 30,
        style: styleHeaderCss,
      },
    ],
    data:
      shootingDrillsData && shootingDrillsData.length > 0
        ? shootingDrillsData[7].map((record) => ({
            region: record.region ? record.region : 0,
            result: record.result ? record.result : 0,
            percentage: record.percentage ? record.percentage : 0,
          }))
        : [],
    columnStyles: Array(3).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  return [
    shootingDrils,
    spotUpDrillData,
    threePointStarDrillData,
    midRangeStarDrillData,
    sideMidSideStarDrillData,
    midSideMidStarDrillData,
    offTheDribbleDrillData,
    freeThrowsDrillData,
  ];
};
